import React from "react";
import Button from "../../components/Button";
import CreditCardV2 from "./CreditCardV2";
import { isCardType } from "../../lib/Money";

const CreditCardPaymentMethodV2 = (props) => {

  if (!props.show) return null;
  const card = props.defaultPaymentMethod;
  let element = null;
  // eslint-disable-next-line
  let hasCard = false;
  let label = "";
  let buttonPrimary = false;
  let action = null;

  if (card && isCardType(card.get("type"))) {
    hasCard = true;
    label = "Change Card";
    action = props.onChangeCard;
    element = <CreditCardV2 key={card.get("cardId")} card={card} />
  } else {
    hasCard = false;
    label = "Add Card";
    action = props.onAddCard;
    buttonPrimary = props.usePrimaryButtonForAdd;
    element = (
      <p className="helptext">No credit card on file.</p>
    )
  }

  return (
    <div className="CreditCardPaymentMethod">
      {element}
      <div className="buttons">
        <Button label={label} primary={buttonPrimary} onClick={action} />
      </div>
    </div>
  )

}

CreditCardPaymentMethodV2.defaultProps = {
  usePrimaryButtonForAdd: true,
  show: true
}

export default CreditCardPaymentMethodV2;